import React from 'react';
import '../../styles/CaseStudyThree/CaseStudiesTesting3.css';

const CaseStudiesTesting3 = () => {
  return (
    <section className="testing-section3">
      <div className="testing-container3">
        <h2 className="testing-section-title3">Testing and Optimization</h2>
        <p className="testing-section-description3">
        During the testing and optimization phase, we focused on refining Hawx Pest Control's audience targeting to ensure their ads reached the most qualified potential customers.
         By analyzing demographic data and customer behavior, we identified opportunities to exclude non-converting audiences, 
        such as lower-income households and younger individuals unlikely to own homes. This allowed us to allocate ad spend more effectively, prioritizing high-intent leads and maximizing campaign efficiency.
        </p>

        {/* Row 1 */}
        <div className="testing-row3">
          <div className="testing-content3">
            <div className="testing-checkmark-icon3"></div>
            <div>
              <h4 className="testing-title3">Income Targeting</h4>
              <p className="testing-text3">
              We implemented audience segmentation to exclude lower-income households, focusing instead on middle-to-high-income homeowners. This allowed us to maximize ad spend on households that could afford pest control services.
              </p>
            </div>
          </div>
          <div className="testing-image-placeholder3">
          <img
              src={require("../../assets/money-bullseye.png")}
              alt="Bot"
              className="testing-section-image3"
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="testing-row reverse3">
          <div className="testing-content3">
            <div className="testing-checkmark-icon3"></div>
            <div>
              <h4 className="testing-title3">Age Demographics</h4>
              <p className="testing-text3">
              Younger audiences (ages 18–24) were excluded due to their lower likelihood of homeownership. By prioritizing older demographics, we reached a higher percentage of qualified leads.
              </p>
            </div>
          </div>
          <div className="testing-image-placeholder3">
          <img
              src={require("../../assets/family.png")}
              alt="Bot"
              className="testing-section-image3"
            />
          </div>
        </div>

        {/* Row 3 */}
        <div className="testing-row3">
          <div className="testing-content3">
            <div className="testing-checkmark-icon3"></div>
            <div>
              <h4 className="testing-title3">Ongoing Campaign Refinement</h4>
              <p className="testing-text3">
              Through constant performance analysis, we refined our campaigns to further optimize CPL and lead quality, ensuring every dollar spent delivered measurable results.
              </p>
            </div>
          </div>
          <div className="testing-image-placeholder3">
          <img
              src={require("../../assets/finger-gear.png")}
              alt="Bot"
              className="testing-section-image3"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesTesting3;